














import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {DynamicDocumentUtils} from '@/views/dynamicdocuments/dynamic-document.utils';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import DynamicDocumentDateFieldTemplate from '../fields/dynamic-document-date-field-template.vue';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';

@Component({
  name: 'dynamic-document-date-brick-template',
  components: {
    DynamicDocumentScreenWidthConfigurationTemplate,
    DynamicDocumentDateFieldTemplate
  }
})
export default class DynamicDocumentDateBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldDtoV2 | undefined;
  @Prop({required: true}) context: DisguiseDto.DynamicDocumentContextDto | undefined;

  sizes = DynamicDocumentUtils.SIZE_SELECTOR;
  contextSelectValues: DisguiseDto.SelectDto[] = [];

  created() {
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DynamicDocumentReplacementTokenDto[]>(
      `/dynamicdocuments/v1/documents/contexttypes/${this.context}/replacementtoken/date`
    ).then((response) => {
      const newContextSelectValues: DisguiseDto.SelectDto[] = [{
        value: '',
        text: ''
      }];
      for (const currentReplacementToken of response.data) {
        newContextSelectValues.push({
          text: currentReplacementToken.tokenName,
          value: currentReplacementToken.replacementToken
        });
      }
      this.contextSelectValues = newContextSelectValues;
    });
  }

}
